import { render, staticRenderFns } from "./SectionManage.vue?vue&type=template&id=2a72b366&scoped=true&"
import script from "./SectionManage.vue?vue&type=script&lang=js&"
export * from "./SectionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a72b366",
  null
  
)

export default component.exports